import api from './index.js'

export default {

  getInvoicePdfUrl() {
    return api.baseUrl() + 'companies/invoice/{token}';
  },
  getTimezones() {
    return api.get('companies/timezones.json');
  },
  setTimezone(params) {
    return api.post('companies/timezone', params);
  },
  invoiceList(params) {
    return api.get('companies/invoice_list', params);
  },
  invoiceDlToken(year, month) {
    return api.get(`companies/invoice_dl_token/${year}/${month}`);
  },
  resetSdkToken() {
    return api.post('companies/reset_sdk_token');
  },
  createCompany(params) {
    return api.post('/register/new_company', params);
  }
}
